import React from "react";
import { FC } from "react";
import { Paper, Theme, makeStyles } from "@material-ui/core";
import useUserQueries from "../../../hooks/useUserQueries";
import { useQuery } from "react-query";
import Loading from "../../../../../components/Loading";
import { mutateErrors } from "../../../../../utils";
import Error from "../../../../../components/Error";
import Container from "@material-ui/core/Container";
import PageHeader from "../../../../../components/PageHeader";
import { QUERY_KEYS } from "../../../../../constants";
import { UserRole } from "../../../enums/UserRole";
import SchoolUsersList from "../../../components/SchoolUsersList";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    padding: theme.spacing(3),
  },
}));

const SchoolPage: FC = () => {
  const classes = useStyles();

  const { fetchAll } = useUserQueries();

  const { adminUsersList } = QUERY_KEYS;

  const { isLoading, isFetching, refetch, isError, error, data } =
    useQuery<any>([adminUsersList, UserRole.School], () =>
      fetchAll(UserRole.School),
    );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  const users = data.data;

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Schools"}
          subtitle={"Here are listed school users"}
        />
      </Container>
      <Container maxWidth="lg" className={classes.container}>
        <Paper className={classes.paper}>
          <SchoolUsersList schoolUsers={users} refetch={refetch} />
        </Paper>
      </Container>
    </>
  );
};

export default React.memo(SchoolPage);
